import { isDestroyed, isDestroying } from '@ember/destroyable';
import { fn, get } from '@ember/helper';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { action, computed } from '@ember/object';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert, didUpdate } from '@ember/render-modifiers';
import { type Registry as Services, service } from '@ember/service';
import { t } from 'ember-intl';
import GeneralCalendarsCalendarRange from 'lumen/components/general/calendars/calendar-range';
import GeneralDatepickersDatepickerWithSidebar from 'lumen/components/general/datepickers/datepicker-with-sidebar';
import GeneralDropdownsDropdownYield from 'lumen/components/general/dropdowns/dropdown-yield';
import GeneralDropdownsSidebar from 'lumen/components/general/dropdowns/sidebar';
import GeneralFormFieldsCancelAndConfirm from 'lumen/components/general/form-fields/cancel-and-confirm';
import HotelBenchmarkInsightDropdownsTriggersTriggerReferencePeriod from 'lumen/components/hotel/benchmark-insight/dropdowns/triggers/trigger-reference-period';
import { BENI_REFERENCE_PERIOD_SHORT_TRANSLATIONS } from 'lumen/utils/constants/benchmark-insight/beni-constant-values';

// @ts-expect-error: Incorrect type
export default class HotelBenchmarkInsightDatePickersDatePickerReferencePeriod extends GeneralDatepickersDatepickerWithSidebar {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  BENI_REFERENCE_PERIOD_SHORT_TRANSLATIONS =
    BENI_REFERENCE_PERIOD_SHORT_TRANSLATIONS;

  triggerComponent =
    HotelBenchmarkInsightDropdownsTriggersTriggerReferencePeriod;

  @computed('args.referencePeriod', 'tempOption.id')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isApplyDisabled() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return this.tempOption.id === this.args.referencePeriod;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get maxDate() {
    // Reference period always needs to be in the past, compared to the current period.
    // Therefore, use the start date of the current period as the max date.
    return this.hotelAndMarketService.toLocalTime(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
      this.args.selectedDateRange.start,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get minDate() {
    return this.hotelAndMarketService.toLocalTime(
      // @ts-expect-error: Incorrect type
      this.hotelAndMarketService.hotel.benchmarkInsightFirstAvailableStayDate,
    );
  }

  @action
  // @ts-expect-error: Incorrect type
  applyChanges(dropdown): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.args.onChangeReferencePeriod(this.tempOption.id);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    dropdown.toggleDropdown();
  }

  @action
  onCancel(): void {
    if (isDestroyed(this) || isDestroying(this)) {
      return;
    }

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.updateTempRange(this.convertedRange, this.args.referencePeriod);
  }

  <template>
    <div
      class="flex-date-picker-container flex flex-row items-center justify-start"
      {{didInsert
        (fn this.updateTempRange this.convertedRange @referencePeriod)
      }}
      {{didUpdate
        (fn this.updateTempRange this.convertedRange @referencePeriod)
        @referencePeriod
      }}
    >
      <GeneralDropdownsDropdownYield
        @onCancel={{this.onCancel}}
        {{! @glint-expect-error: Incorrect type }}
        @selected={{t
          (get this.BENI_REFERENCE_PERIOD_SHORT_TRANSLATIONS @referencePeriod)
        }}
        @triggerComponent={{this.triggerComponent}}
        as |dropdown|
      >
        <section class="date-picker-with-side-bar-calendar">
          <section class="date-picker-with-side-bar-calendar__content">
            <div class="mb-500">
              {{! @glint-expect-error: Incorrect type }}
              <GeneralCalendarsCalendarRange
                @canSelectMonth={{false}}
                @displayEvents={{false}}
                @isDisabled={{true}}
                @maxDate={{this.maxDate}}
                @minDate={{this.minDate}}
                @refocusMonths={{this.refocusMonths}}
                @selectedRange={{this.tempRange}}
              />
            </div>

            <GeneralDropdownsSidebar
              @selectOption={{this.selectOption}}
              @sidebarLists={{this.convertedSidebarLists}}
            />
          </section>

          <section class="date-picker-with-side-bar-calendar__footer">
            <div class="datepicker-save-cancel">
              <GeneralFormFieldsCancelAndConfirm
                @cancel={{fn this.cancelChanges dropdown}}
                @confirm={{fn this.applyChanges dropdown}}
                @isConfirmDisabled={{this.isApplyDisabled}}
              />
            </div>
          </section>
        </section>
      </GeneralDropdownsDropdownYield>
    </div>
  </template>
}
